import React, { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import { Header } from "@/components/Header";
import { BottomNav } from "@/components/BottomNav";
import { Library } from "@/components/Library";
import { SettingsView } from "@/components/SettingsView";
import { MiniPlayer } from "@/components/MiniPlayer";
import { FullPlayer } from "@/components/FullPlayer";
import { bgStyle } from "@/lib/format";

function Shell() {
  const { bg, currentSong, loading } = useApp();
  const [view, setView] = useState("library");

  return (
    <div className="relative h-[100dvh] w-full overflow-hidden text-white">
      <div data-testid="app-background" className="fixed inset-0 -z-20" style={bgStyle(bg)} />
      <div className="fixed inset-0 -z-10 bg-black/45" />
      <div className="fixed inset-0 -z-10 noise pointer-events-none" />

      <div className="mx-auto max-w-md h-full flex flex-col">
        <Header view={view} setView={setView} />
        <main data-testid="main-view" className="flex-1 overflow-y-auto no-scrollbar px-4 pb-44">
          {loading ? (
            <div className="pt-24 text-center text-white/40 text-sm">…</div>
          ) : view === "library" ? (
            <Library />
          ) : (
            <SettingsView />
          )}
        </main>
      </div>

      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-30">
        {currentSong && <MiniPlayer />}
        <BottomNav view={view} setView={setView} />
      </div>

      <FullPlayer />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <Shell />
    </AppProvider>
  );
}
